import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "read-the-brief",
  courseId: "investigations",
  order: 4,
  title: "The Brief",
  subtitle: "And what changed",
  summary:
    "The Brief is a cross-call summary the AI rewrites after every batch. Each revision says what changed, and every past version is kept.",
  learn: [
    "Read the Brief's headline, summary, and open questions",
    "Use the What changed card after new uploads",
    "Understand what a Brief never does",
  ],
  minutes: 3,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "paragraph",
      text: "When you have added a batch and want to know where the case stands, open the Brief. Once a batch settles, a rollup reads every call summary, lead, entity, and document summary and writes what the investigation appears to be about, who the players are, what is unresolved, and a timeline with sources.",
    },
    {
      type: "steps",
      items: [
        "Open the Brief tab.",
        "After new uploads, read the \"What changed\" card at the top. It lists what the newest files added or altered, with items marked as new since the last brief.",
        "Click a timeline entry to open its source: the lead's exact second, the document page, or the call.",
      ],
    },
    {
      type: "paragraph",
      text: "If files were deleted after the brief was written, a notice says so. The next rollup scrubs references to them.",
    },
    {
      type: "callout",
      tone: "note",
      title: "What the Brief leaves alone",
      text: "It never edits your leads, notes, dismissals, or the speaker names you set. It is generated from them. Uploading more files adds analysis. It does not re-run or overwrite earlier work.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Re-run analysis is a full reset",
      text: "The owner's \"Re-run analysis\" button in the header analyzes every file again from scratch. Use it after a change to the investigation's focus, not after a routine upload.",
    },
    {
      type: "paragraph",
      text: "Leads queue is the next place to check, since the Brief is built from the leads you confirm and dismiss.",
    },
  ],
  related: ["work-the-leads-queue", "people-connections-timeline", "export-and-discovery"],
};

export default lesson;
